import { IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from "@mui/material";
import { DesignServicesRounded, LanguageRounded } from "@mui/icons-material";
import { useState } from "react";
import { ScreenShare } from "@zesty-io/material";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../../../../shell/store/types";
import { useDomain } from "../../../../../../../../shell/hooks/use-domain";
import { ContentItemWithDirtyAndPublishing } from "../../../../../../../../shell/services/types";
import { useGetItemPublishingsQuery } from "../../../../../../../../shell/services/instance";
import { useTranslation } from "react-i18next";
export const PreviewMenu = () => {
  const {
    t
  } = useTranslation();
  const {
    modelZUID,
    itemZUID
  } = useParams<{
    modelZUID: string;
    itemZUID: string;
  }>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const domain = useDomain();
  const item = useSelector((state: AppState) => state.content[itemZUID] as ContentItemWithDirtyAndPublishing);
  const {
    data: itemPublishings
  } = useGetItemPublishingsQuery({
    modelZUID,
    itemZUID
  });
  const activePublishing = itemPublishings?.find(itemPublishing => itemPublishing._active);
  const instance = useSelector((state: AppState) => state.instance);
  const previewLock = useSelector((state: AppState) => state.settings.instance.find((setting: any) => setting.key === "preview_lock_password" && setting.value));
  const pathPart = item && Object.keys(item.web).length && item.web.pathPart !== "zesty_home" ? item.web.path : "";
  const prodUrl = domain + pathPart;
  let devUrl = `${CONFIG.URL_PREVIEW_PROTOCOL}${instance.randomHashID}${CONFIG.URL_PREVIEW}${item?.web?.path}`;
  if (previewLock) {
    devUrl = `${devUrl}?zpw=${previewLock.value}`;
  }
  return <>
      <Tooltip title={t("content.itemEditPreviewPage")} enterDelay={1000} enterNextDelay={1000} placement="bottom-start" data-sentry-element="Tooltip" data-sentry-source-file="PreviewMenu.tsx">
        <IconButton size="small" onClick={event => {
        setAnchorEl(event.currentTarget);
      }} data-sentry-element="IconButton" data-sentry-source-file="PreviewMenu.tsx">
          <ScreenShare fontSize="small" data-sentry-element="ScreenShare" data-sentry-source-file="PreviewMenu.tsx" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={!!anchorEl} anchorOrigin={{
      vertical: "bottom",
      horizontal: "right"
    }} transformOrigin={{
      vertical: -8,
      horizontal: "right"
    }} onClose={() => {
      setAnchorEl(null);
    }} data-sentry-element="Menu" data-sentry-source-file="PreviewMenu.tsx">
        <MenuItem onClick={() => {
        setAnchorEl(null);
        window.open(devUrl, "_blank");
      }} data-sentry-element="MenuItem" data-sentry-source-file="PreviewMenu.tsx">
          <ListItemIcon data-sentry-element="ListItemIcon" data-sentry-source-file="PreviewMenu.tsx">
            <DesignServicesRounded data-sentry-element="DesignServicesRounded" data-sentry-source-file="PreviewMenu.tsx" />
          </ListItemIcon>
          {t("content.itemEditDraftPreviewVersion", {
          version: item?.meta?.version
        })}
        </MenuItem>
        {activePublishing && <MenuItem onClick={() => {
        setAnchorEl(null);
        window.open(prodUrl, "_blank");
      }}>
            <ListItemIcon>
              <LanguageRounded />
            </ListItemIcon>
            {t("content.itemEditProductionPreviewVersion", {
          version: activePublishing?.version
        })}
          </MenuItem>}
      </Menu>
    </>;
};